import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { LANDING_PAGE } from "constants/localstorage";
import { setCookie } from "services/cookies-service";
const MAX_PAGES = 5;
const getStoredPages = ()=>{
    const stored = localStorage.getItem(LANDING_PAGE);
    if (!stored) {
        return [];
    }
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
};
const LandingPageTracker = ()=>{
    useEffect(()=>{
        try {
            const currentPage = window.location.pathname;
            const pages = getStoredPages();
            const lastPage = pages[pages.length - 1];
            // Only add if different from the last page (avoid duplicates on refresh)
            if ((lastPage === null || lastPage === void 0 ? void 0 : lastPage.value) === currentPage) {
                return;
            }
            pages.push({
                value: currentPage,
                timestamp: Date.now()
            });
            // Keep only the last 5 pages
            const pagesToStore = pages.length > MAX_PAGES ? pages.slice(-MAX_PAGES) : pages;
            const serializedPages = JSON.stringify(pagesToStore);
            localStorage.setItem(LANDING_PAGE, serializedPages);
            setCookie(LANDING_PAGE, serializedPages, {
                expires: 1 / 24,
                domain: `.${window.location.hostname}`
            });
        } catch (e) {
            Sentry.captureException(e);
        }
    }, []);
    return null;
};
export default LandingPageTracker;
